import { render, staticRenderFns } from "./SpeakerStarsInput.vue?vue&type=template&id=df8b031c&scoped=true&"
import script from "./SpeakerStarsInput.vue?vue&type=script&lang=js&"
export * from "./SpeakerStarsInput.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerStarsInput.vue?vue&type=style&index=0&id=df8b031c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8b031c",
  null
  
)

export default component.exports